module.exports = __webpack_public_path__ + "media/images/logo_purple-b9cdf0f6de3b88c8b4b968fb1f9234df.png";